import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_pfe5z89pnk: FaireBrandEntity = {
  token: "b_pfe5z89pnk",
  type: "brand",
  name: "Vrinda",
  avatarUrl:
    "https://cdn.faire.com/fastly/322c7611ec6ac47b091bc73b4a804a8af90bbde04f902a07c36e5042b71749dc.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/e549929b4034af280da7b4bd924476a7652b9157f852c480996dc2f5674b0e58.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/322c7611ec6ac47b091bc73b4a804a8af90bbde04f902a07c36e5042b71749dc.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e549929b4034af280da7b4bd924476a7652b9157f852c480996dc2f5674b0e58.jpeg",
  location: "Miami, FL, USA",
  minimumOrderDollars: 139,
  rating: 4.8,
  reviewCount: 17,
  isInsider: true,
  description:
    "Established in 2008, we are a family-owned B2B export-import business based in Miami, USA, dedicated to the creation and global distribution of healing and meditational products. Our offerings include premium incense, candles, and spiritual accessories — thoughtfully crafted to support mindfulness, well-being, and sacred living.\n\nWith a strong and growing network of wellness-focused businesses and retailers, our products are distributed across North America, South America, and the Caribbean. We are proud to serve as a trusted partner in the global wellness community, bringing meaningful products to those who seek balance, peace, and spiritual connection.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:45.315Z",
    importedBy: "entity-db-cli",
  },
};
